import React, { useCallback, useEffect, useMemo } from 'react';
import DOMPurify from 'dompurify';
import PropTypes from 'prop-types';

import { SiteConfigManager, useSettings, useStaticBlock, useStaticBlocksState } from '@atlas/core';
import { Loader } from '@atlas/ui';

const StaticBlock = ({ className = '', fallback = null, options = {} }) => {
  const { addStaticBlock } = useStaticBlocksState();
  const { content, loading } = useStaticBlock(options.source);

  const { lang } = useSettings();

  useEffect(() => {
    if (SiteConfigManager.getConfig('config.config.useStaticBlocksFromConfig', false)) {
      addStaticBlock({
        [options.source]:
          SiteConfigManager.getConfig(`config.staticBlocks.${options.source}.i18n.${lang}.text`) ||
          SiteConfigManager.getConfig(`config.staticBlocks.${options.source}.i18n.ENG.text`) ||
          '',
      });
    }
  }, [addStaticBlock, lang, options.source]);

  const renderStaticContent = useCallback(
    content => {
      const cleanHtml = {
        __html: DOMPurify.sanitize(content, { ADD_ATTR: ['target'], KEEP_CONTENT: true }),
      };

      return <div className={className} dangerouslySetInnerHTML={cleanHtml} />;
    },
    [className],
  );

  const renderView = useMemo(() => {
    if (loading)
      return (
        <div>
          <Loader />
        </div>
      );

    if (content) return renderStaticContent(content);

    return fallback;
  }, [loading, content, renderStaticContent, fallback]);

  return <div className="static">{renderView}</div>;
};

StaticBlock.propTypes = {
  className: PropTypes.string,
  fallback: PropTypes.node,
  options: PropTypes.object,
};

export default React.memo(StaticBlock);
